import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { CheckCircleTwoTone } from '@ant-design/icons';
import type { ProjectDto } from '../../../../../api/generated/model';
import { usePutApiProjectsUpdateDimensionDocUpdatedProjectId } from '../../../../../api/generated/endpoints/project/project';
import { getApiSharepointDocumentLinkProjectId } from '../../../../../api/generated/endpoints/share-point/share-point';

interface DimensionDocumentsAccordionItemProps {
    projectInfo: ProjectDto | undefined;
    dimensionDocUpdated: boolean;
    setDimensionDocUpdated: React.Dispatch<React.SetStateAction<boolean>>;
    workerView: boolean;
}

const DimensionDocumentsAccordionItem: React.FC<DimensionDocumentsAccordionItemProps> = ({
    projectInfo,
    dimensionDocUpdated,
    setDimensionDocUpdated,
    workerView,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    
    // Mutation for updating dimension doc status
    const updateDimensionDocMutation = usePutApiProjectsUpdateDimensionDocUpdatedProjectId({
        mutation: {
            onSuccess: () => {
                setDimensionDocUpdated(true);
            },
        },
    });

    useEffect(() => {
        if (projectInfo?.sharePointFolderId != null) {
        }
    }, [projectInfo]);

    const handleOpenDimensionDocuments = async () => {
        if (!projectInfo?.id) {
            return;
        }

        setIsLoading(true);
        try {
            const documentLink = await getApiSharepointDocumentLinkProjectId(
                projectInfo.id,
                { fileName: "Layher Allround-", fallbackFolderName: "Dimensioneringshandlingar" }
            );
            if (documentLink) {
                window.open(documentLink, '_blank');
                // Update the dimension doc status
                updateDimensionDocMutation.mutate({ projectId: projectInfo.id });
            }
        } catch (error) {
            console.error('Error opening dimension documents:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {projectInfo &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="8">
                    <Accordion.Header className={workerView ? "disabled-header" : ""}>
                        Dimensioneringshandlingar
                        {dimensionDocUpdated && <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '25px', marginLeft: '10px' }} />}
                    </Accordion.Header>
                    <Accordion.Body className={workerView ? "disabled-body" : ""}>
                        {projectInfo.sharePointFolderId != null ? (
                            <div
                                onClick={handleOpenDimensionDocuments}
                                style={{
                                    color: isLoading ? '#999' : '#0066cc',
                                    textDecoration: 'underline',
                                    cursor: isLoading ? 'wait' : 'pointer'
                                }}
                                role="button"
                                tabIndex={0}
                            >
                                {isLoading 
                                    ? 'Söker efter dimensioneringshandlingar...'
                                    : `Öppna dimensioneringshandlingar för ${projectInfo.customer?.name}-${projectInfo.projectNumber}/${projectInfo.projectName}`
                                }
                            </div>
                        ) : (
                            <div>Projektet måste laddas upp till Sharepoint för att dimensioneringshandlingarna ska vara tillgängliga</div>
                        )}
                    </Accordion.Body>
                </Accordion.Item>
            }
        </>
    );
};

export default DimensionDocumentsAccordionItem; 